var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('employee-view-content',{attrs:{"employee-id":Number(_vm.$route.params.Id),"user":_vm.$store.getters.user}})}
var staticRenderFns = []

export { render, staticRenderFns }